<script setup lang="ts">
import { capitalize } from "vue";
const { t } = useI18n();
</script>

<template>
	<div>
		<div class="flex flex-col">
			<LayoutLogo />
			<address class="mt-7 text-sm text-green-dark not-italic">
				<p class="whitespace-nowrap">
					{{ capitalize(t('forWholesaleCooperation')) }}
				</p>
				<div class="flex flex-col">
					<LayoutFooterSocialAddress link="tel:+380631577127">
						+38(063)157-71-27
					</LayoutFooterSocialAddress>
				</div>
			</address>
			<div class="mt-8 flex gap-x-4">
				<LayoutFooterSocialButton
					link="https://www.instagram.com/valley_arts"
					icon-name="mdi:instagram"
				/>
				<LayoutFooterSocialButton
					link="https://pinterest.com/valleyarts"
					icon-name="mdi:pinterest"
				/>
			</div>
		</div>
	</div>
</template>
